import { makeStyles } from 'tss-react/mui';

export const navbarStyles = makeStyles()((theme) => ({
  // ─── AppBar root ─────────────────────────────────────────────────────────────
  appBar: {
    // Glass-morphism base: white with a barely-visible purple tint
    background: 'rgba(255, 255, 255, 0.92)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',

    // Remove the heavy box-shadow in favour of a single hairline bottom border
    boxShadow: 'none',
    borderBottom: `1px solid rgba(87, 46, 136, 0.10)`,

    // Subtle top highlight that gives the glass a lifted feel
    backgroundImage:
      'linear-gradient(180deg, rgba(87, 46, 136, 0.04) 0%, rgba(255, 255, 255, 0) 100%)',

    padding: '0 1rem',
    // Account for notch/status bar on iOS
    paddingTop: 'env(safe-area-inset-top, 0px)',

    // Sticky: stay on top when scrolling
    top: 0,
    zIndex: 1100,

    // Hide on desktop — sidebar handles navigation
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },

    // Smooth repaint when the user scrolls and the bar transitions between states
    transition: 'background 0.25s ease, box-shadow 0.25s ease',

    // ── Toolbar height override ─────────────────────────────────────────────
    '& .MuiToolbar-root': {
      minHeight: '68px',
      justifyContent: 'flex-start',

      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        minHeight: '60px',
      },
    },
  },

  // ─── Inner layout ─────────────────────────────────────────────────────────────
  toolbarInner: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
  },

  // ─── Left section (profile + mobile WhatsApp) ────────────────────────────────
  sectionLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.25rem',
  },

  // ─── Center section (logo) ────────────────────────────────────────────────────
  sectionCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  // ─── Right section (WhatsApp desktop + bell + dashboard) ────────────────────
  sectionRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // Tighten the default MUI IconButton padding so items sit closer together
    // while still giving enough tap-target size
    gap: '0.15rem',

    // Wrap every direct IconButton child in a hover pill effect without touching
    // the sub-component files
    '& .MuiIconButton-root': {
      borderRadius: '10px',
      padding: '8px',
      transition:
        'background-color 0.18s ease, transform 0.15s ease, box-shadow 0.18s ease',

      '&:hover': {
        backgroundColor: 'rgba(87, 46, 136, 0.08)',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 8px rgba(87, 46, 136, 0.12)',
      },

      '&:active': {
        transform: 'translateY(0)',
        boxShadow: 'none',
        backgroundColor: 'rgba(87, 46, 136, 0.14)',
      },
    },
  },

  // ─── Mobile-only WhatsApp slot ───────────────────────────────────────────────
  mobileWhatsapp: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },

    '& .MuiIconButton-root': {
      borderRadius: '10px',
      padding: '8px',
      transition:
        'background-color 0.18s ease, transform 0.15s ease, box-shadow 0.18s ease',

      '&:hover': {
        backgroundColor: 'rgba(87, 46, 136, 0.08)',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 8px rgba(87, 46, 136, 0.12)',
      },

      '&:active': {
        transform: 'translateY(0)',
        boxShadow: 'none',
        backgroundColor: 'rgba(87, 46, 136, 0.14)',
      },
    },
  },

  // ─── Desktop-only WhatsApp slot ──────────────────────────────────────────────
  desktopWhatsapp: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },

  // ─── Legacy icon classes (kept for any residual internal usage) ───────────────
  icon: {
    width: '40px',
    cursor: 'pointer',
    position: 'absolute',
    margin: '0 0.5em',
  },
  icon_white_label: {
    width: '40px',
  },
  iconImage: {
    margin: '0 auto',
  },
  spacer: {
    flexGrow: 1,
  },
}));
